import React from "react";
import { geoCentroid } from "d3-geo";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
    Annotation
} from "react-simple-maps";
import allStates from "../../usStates.json";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const offsets = {
    VT: [-40, -40],
    NH: [-15, -60],
    MA: [65, -60],
    RI: [60, -30],
    CT: [50, 5],
    NJ: [35, 1],
    DE: [40, 20],
    MD: [60, 60],
    DC: [40, 100],
};

const offsetsText = {
    VT: [-11, -32, -6, -20, -20, -8],
    NH: [-11, -32, -6, -20, -20, -8],
    MA: [3, -12, 8, 0, -4, 12],
    RI: [5, -12, 8, 0, -4, 12],
    CT: [2, -12, 6, 0, -6, 12],
    NJ: [2, -10, 6, 2, -6, 14],
    DE: [2, -11, 6, 1, -6, 13],
    MD: [2, -11, 6, 1, -6, 13],
    DC: [2, -11, 6, 1, -6, 13],
};

const MapChart = ({data, total}) => {
    return (
        <ComposableMap width={980} height={500} projection="geoAlbersUsa">
            <Geographies geography={geoUrl}>
                {({ geographies }) => (
                    <React.Fragment>
                        {geographies.map(geo => {
                            const cur = allStates.find(s => s.val === geo.id);
                            const curData = data.length ? data.find(d => d.company_state === cur.id) : null;
                            const color = curData ? cur.color : "#9EA2A5";
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    stroke="#FFF"
                                    geography={geo}
                                    fill={color}
                                />
                            )
                        })}
                        {geographies.map(geo => {
                            const centroid = geoCentroid(geo);
                            const cur = allStates.find(s => s.val === geo.id);
                            let curData = data.length ? data.find(d => d.company_state === cur.id) : null;
                            if (!curData) {
                                return;
                            }
                            const percent = total ? (curData.total_properties / total * 100).toFixed(2) : 0;

                            return (
                                <g key={geo.rsmKey + "-name"}>
                                    {cur &&
                                    centroid[0] > -160 &&
                                    centroid[0] < -67 &&
                                    (Object.keys(offsets).indexOf(cur.id) === -1 ? (
                                        <Marker coordinates={centroid}>
                                            <text x={cur.id === 'FL' ? 12 : 0} y="-4" fontSize={13} fontWeight="bold" textAnchor="middle">
                                                {cur.id}
                                            </text>
                                            <text x={cur.id === 'FL' ? 12 : 0} y="7" fontSize={11} textAnchor="middle">
                                                {curData.total_properties}
                                            </text>
                                            <text x={cur.id === 'FL' ? 16 : 0} y="18" fontSize={11} textAnchor="middle">
                                                ({percent}%)
                                            </text>
                                        </Marker>
                                    ) : (
                                        <Annotation
                                            subject={centroid} dx={offsets[cur.id][0]} dy={offsets[cur.id][1]}>
                                            <text
                                                x={offsetsText[cur.id][0]} y={offsetsText[cur.id][1]}
                                                fontSize={14} fontWeight={'bold'} alignmentBaseline="middle">
                                                {cur.id}
                                            </text>
                                            <text x={offsetsText[cur.id][2]} y={offsetsText[cur.id][3]}
                                                  fontSize={11} alignmentBaseline="middle">
                                                {curData.total_properties}
                                            </text>
                                            <text x={offsetsText[cur.id][4]} y={offsetsText[cur.id][5]}
                                                  fontSize={11} alignmentBaseline="middle">
                                                ({percent}%)
                                            </text>
                                        </Annotation>
                                    ))}
                                </g>
                            );
                        })}
                    </React.Fragment>
                )}
            </Geographies>
        </ComposableMap>
    );
};

export default MapChart;
